var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { utility } from '../../../utils';
import constants from '../../../config/constants';
import { EXPORT_NUMBER_FORMATS, exportTable } from '../../../utils/exportTable';
import { getVisibleFundingLogColumns } from './FundingLogTable';
import { ASSIGNEE_TIER_LABEL } from './FundingLogBadges';
var formatAssignee = function (row) {
    var tier = row.assigneeTier ? ASSIGNEE_TIER_LABEL[row.assigneeTier] : '';
    if (row.assigneeName && tier)
        return "".concat(row.assigneeName, " (").concat(tier, ")");
    return row.assigneeName || tier || 'Unassigned';
};
var CELL_OVERRIDES = {
    assigneeName: { value: formatAssignee },
    amount: { value: function (row) { return Number(row.amount) || 0; }, numberFormat: EXPORT_NUMBER_FORMATS.currency },
};
var toExportColumn = function (column) { return (__assign({ header: column.header, width: Math.max(column.header.length + 2, Math.round(column.width / 7)), value: function (row) {
        var value = row[column.key];
        return typeof value === 'string' || typeof value === 'number' ? value : undefined;
    } }, CELL_OVERRIDES[column.key])); };
export var exportFundingLog = function (_a) {
    var fetchRows = _a.fetchRows, format = _a.format, viewLabel = _a.viewLabel, visibleColumnKeys = _a.visibleColumnKeys;
    return __awaiter(void 0, void 0, void 0, function () {
        var result, rows, total;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, fetchRows()];
                case 1:
                    result = _b.sent();
                    if (result === null) {
                        utility.alert('Unable to export the deals. Please try again.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    rows = result.rows, total = result.total;
                    if (rows.length < total) {
                        utility.alert("Exported ".concat(rows.length, " of ").concat(total, " deals in ").concat(viewLabel, " - the rest couldn't be loaded."), constants.TOAST_TYPES.WARN);
                    }
                    if (rows.length === 0) {
                        utility.alert("There are no deals in ".concat(viewLabel, " to export."), constants.TOAST_TYPES.INFO);
                        return [2];
                    }
                    return [4, exportTable({
                            rows: rows,
                            columns: getVisibleFundingLogColumns(visibleColumnKeys).map(toExportColumn),
                            format: format,
                            fileName: "Funding Queue ".concat(viewLabel),
                            sheetName: 'Funding Queue',
                        })];
                case 2:
                    _b.sent();
                    return [2];
            }
        });
    });
};
